import { Coins, Loader, Plus } from "lucide-react";

interface ChipProps {
  text: string;
  value: string;
  onClick: () => void;
  loading: boolean;
}

export const Chip = ({ text, value, onClick, loading }: ChipProps) => {
  const isZero = value === "0" || parseInt(value) === 0;
  
  return (
    <div className="bg-gray-50 rounded-[38px] shadow-sm p-2 flex items-center justify-between gap-2 mb-6">
      <div className="bg-white rounded-[30px] px-3 py-1.5 flex items-center gap-2">
        <span className="text-gray-700 font-medium text-sm">
          {text}
        </span>
        <div className={`rounded-full px-3 py-1 flex items-center gap-1.5 ${
          isZero 
            ? "bg-red-50" 
            : "bg-green-50"
        }`}>
          <Coins className={`w-4 h-4 ${
            isZero 
              ? "text-red-400" 
              : "text-green-500"
          }`} />
          <span className={`font-semibold text-sm ${
            loading ? "text-gray-500" : isZero 
              ? "text-red-500" 
              : "text-green-600"
          }`}>
            {loading ? <Loader size={16} color="#6569f1" /> : value}
          </span>
        </div>
      </div>
      <button
        onClick={onClick}
        className="w-9 h-9 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center transition-colors shadow-md hover:shadow-lg"
      >
        <Plus className="w-5 h-5 text-white" />
      </button>
    </div>
  );
};
